import { createAction } from 'redux-act';

import * as apiStatuses from '../../core/apiStatuses';

export const fetchApiStatuses = createAction(
  'get all apiStatuses',
);
export const fetchApiStatusesSuccess = createAction(
  'get all apiStatuses success',
);
export const fetchApiStatusesFail = createAction(
  'get all apiStatuses fail',
);
export const fetchApiStatusesAllCount = createAction(
  'get count of all apiStatuses',
);
export const fetchApiStatusesAllCountSuccess = createAction(
  'get count of all apiStatuses success',
);

export const updateApiStatus = createAction(
  'update api status',
);
export const updateApiStatusSuccess = createAction(
  'update api status success',
);
export const updateApiStatusFail = createAction(
  'update api status fail',
);
export const updateApiStatusFromSocket = createAction(
  'update aoi status from socket',
);
export const updateHeaderBadge = createAction(
  'update header badge',
);

export const reducer = {
  [fetchApiStatuses]: (state, payload) =>
    apiStatuses.fetchApiStatuses(state, payload),
  [fetchApiStatusesSuccess]: (state, payload) =>
   apiStatuses.fetchApiStatusesSuccess(state, payload),
  [fetchApiStatusesAllCount]: state => (state),
  [fetchApiStatusesAllCountSuccess]: (state, payload) =>
    apiStatuses.fetchApiStatusesAllCountSuccess(state, payload),

  [updateApiStatus]: (state, payload) =>
   apiStatuses.updateApiStatus(state, payload),
  [updateApiStatusSuccess]: (state, payload) =>
   apiStatuses.updateApiStatusSuccess(state, payload),
  [updateApiStatusFail]: (state, payload) =>
   apiStatuses.updateApiStatusFail(state, payload),
  [updateApiStatusFromSocket]: (state, payload) =>
    apiStatuses.updateApiStatusFromSocket(state, payload),
  [updateHeaderBadge]: (state, payload) =>
    apiStatuses.updateHeaderBadge(state, payload),

};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/apiStatuses.module.js
 **/